<template>
    <div class="p-4">
        <l-l-selection class="mb-4" :networks="networks" @click="onShow"  />

        <l-info-box class="mb-4" :active="showGrid">Right click the grid to add, edit or delete converted timeseries</l-info-box>

        <hot-table :data="converted_timeseries" :settings="settings" v-show="showGrid" ref="hot">
            <hot-column title="Station" data="station" read-only="true"></hot-column>      
            <hot-column title="Pollutant" data="pollutant" read-only="true"></hot-column>        
            <hot-column title="Source" data="source_notation" read-only="true"></hot-column>
            <hot-column title="Target" data="target_notation" read-only="true"></hot-column>             
            <hot-column title="Factor" data="factor" read-only="true"></hot-column>                   
            <hot-column title="Created by" data="createdby" read-only="true"></hot-column>                   
        </hot-table>

        
        <l-l-add :showing="add" @save="onSave" @close="onClose" :stations="stations" :units="units" />  
        <l-l-edit :showing="edit" @save="onSave" @close="onClose" :stations="stations" :timeserie="tsSelected" :units="units" />      
    </div>
</template>


<script>
import ConvertedService from "@/helpers/services/processing/converted.service";
import LLSelection from "./LLSelection";
import LInfoBox from "@/components/LInfoBox";
import Notify from "@/helpers/notify";
import LLAdd from "./LLAdd";
import LLEdit from "./LLEdit";

import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";

export default {
    name:"Converted",
    components: {        
        LLSelection,
        HotTable,
        HotColumn,
        LInfoBox,
        LLAdd,
        LLEdit
    },
    data() {
        return {            
            add: false,
            edit:false,
            showGrid: false,
            networks: [],
            stations: [],
            units:[],
            netSelected: null,
            tsSelected: {},
            converted_timeseries: [],            
            settings: HandsontableHelper.settings(false)
        };
    },
    mounted() {
        this.settings.afterSelectionEnd = this.selectRowOnly;
        this.settings.dropdownMenu = false;
        this.settings.contextMenu = ContextMenu(this);
        Notify.loadData(null, this.loadInitialData);
    },
    methods: {
        selectRowOnly(r, c, r2, c2) {
            if (this.manualSelection) {
                this.manualSelection = false;
                return;
            }
            const hot = this.$refs.hot.hotInstance;
            hot.deselectCell();
            this.manualSelection = true;
            hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
        },
        async loadInitialData() {
            this.units = await ConvertedService.units();
            this.networks = await ConvertedService.networks();  
        },
        async show(net_id) {
            this.netSelected = net_id;
            this.converted_timeseries = await ConvertedService.converted_timeseries(net_id);
            this.showGrid = true;
        },
        async onShow(net_id) {
            this.stations = this.networks.find((n) => n.value == net_id).stations;
            await Notify.loadData(null,this.show, net_id);            
        },

        async onAdd() {
            this.add = true;
        },
        onEdit (t, o) {
            if(o.length > 0) {
                const clickedRow = o[0].start.row;
                const hot = this.$refs.hot.hotInstance;
                const physicalIndex = hot.toPhysicalRow(clickedRow);
                let row = hot.getSourceDataAtRow(physicalIndex);
                this.tsSelected = row;
                this.edit = true;
            }
        },        
        onDelete (t, o) {
            if(o.length > 0) {
                const clickedRow = o[0].start.row;
                const hot = this.$refs.hot.hotInstance;
                const physicalIndex = hot.toPhysicalRow(clickedRow);
                let row = hot.getSourceDataAtRow(physicalIndex);

                Notify.prompt(async response => {
                if (response) {
                    await Notify.loadData(
                    "Please wait while deleting converted timeserie",
                    async () => {
                        const rowsAffected = await ConvertedService.delete(row.id);
                        const activeEditor = hot.getActiveEditor();
                        hot.alter("remove_row", clickedRow, 1);
                        Notify.success("Converted timeserie deleted!");
                    }
                    );
                }
                }, "This will delete the converted timeserie. <br/><br/>Do you want to continue?");
            }
        },
        async onSave(o) {
            if(o.id) {
                Notify.loadData("Updating converted timeserie", this.update, o);   
            }
            else {
                Notify.loadData("Inserting converted timeserie", this.insert, o); 
            }            
        },
        async insert(o) {
            const res = await ConvertedService.insert(o);
            this.converted_timeseries = await ConvertedService.converted_timeseries(this.netSelected);
            Notify.success("Converted timeserie added!");
        },
        async update(o) {            
            const res = await ConvertedService.update(o);
            this.converted_timeseries = await ConvertedService.converted_timeseries(this.netSelected);
            Notify.success("Converted timeserie updated!");
        },
        async onClose() {
            this.add = false;
            this.edit = false;
            this.tsSelected = {};
        },
    }
}
</script>


<style lang="postcss">
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.2/css/all.min.css";
</style>